export default __webpack_public_path__ + "static/slider-6-1da27edcbddb0667dfbb77bbe12f67c7.jpg";